import { Component, Inject } from '@angular/core';
import { ComplaintAppointment } from '@icc/b2b/shared';
import { DIALOG_DATA, DialogRef } from '@icc/ui';
import { ComplaintService } from '../complaint.service';

@Component({
    selector: 'icc-complaint-appointment-delete-dialog',
    templateUrl: './complaint-appointment-delete-dialog.component.html',
    styleUrls: ['./complaint-appointment-delete-dialog.component.scss'],
})
export class ComplaintAppointmentDeleteDialogComponent {

    constructor(
        private complaintService: ComplaintService,
        private dialogRef: DialogRef,
        @Inject(DIALOG_DATA)
        public data: {
            appointment: ComplaintAppointment;
        },
    ) {}

    removeAppointment() {
        this.complaintService.removeAppointment(this.data.appointment);
        this.close();
    }

    close() {
        this.dialogRef.close();
    }
}
